import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-13/task-01";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "Consider a pulsating sphere of radius R on which every point vibrates in phase with the same amplitude v<sub>R</sub>.<br>Calculate the pressure amplitude at r = R and r = 10R, for kR = 0.1, 1, and 10 to connect each pressure<br>to correct answers, where r is the distance of the center of the sphere and k is the wavenumber.",
  description: "Connect with lines.",
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 2,
      colSpan: {
        "0:0": 3,
      },
      rowsSize: [3, 1],
      colsSize: [5, 1, 6],
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data: "Reminder:",
                  direction: "row",
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/13/task/task-1.svg`,
                  styles: {
                    maxHeight: "100px",
                    maxWidth: "260px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default task;
